import React from 'react';
import { Menu, Bell } from 'lucide-react';
import NotificationBell from '@/components/NotificationBell';
import GlobalSearch from '@/components/GlobalSearch';

export function MobileHeader({ unreadCount, onOpenSidebar, onOpenMessages }) {
  return (
    <div className="lg:hidden flex items-center justify-between px-4 py-4 bg-white/95 backdrop-blur-xl border-b border-gray-200 sticky top-0 z-30">
      <button onClick={onOpenSidebar} className="p-2 rounded-lg hover:bg-gray-100" data-testid="open-sidebar-btn">
        <Menu className="h-6 w-6" />
      </button>
      <img src="/logo.png" alt="Systeme de Gestion LCS" className="h-10 w-auto" />
      <button onClick={onOpenMessages} className="p-2 rounded-lg hover:bg-gray-100 relative" data-testid="mobile-notification-btn">
        <Bell className="h-6 w-6 text-gray-600" />
        {unreadCount > 0 && (
          <span className="absolute top-0 right-0 flex items-center justify-center min-w-[18px] h-[18px] px-1 text-xs font-bold text-white bg-red-500 rounded-full animate-pulse">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        )}
      </button>
    </div>
  );
}

export function DesktopTopBars() {
  return (
    <>
      <div className="hidden lg:block sticky top-0 z-30 bg-white/95 backdrop-blur-xl border-b border-gray-200 px-6 py-3">
        <div className="flex items-center justify-between">
          <GlobalSearch />
          <div className="flex items-center gap-3 ml-4">
            <NotificationBell />
          </div>
        </div>
      </div>
      <div className="fixed inset-0 lg:left-72 pointer-events-none z-0 flex items-center justify-center overflow-hidden">
        <img src="/logo.png" alt="LCS Background" className="opacity-15 w-1/2 h-auto object-contain" />
      </div>
    </>
  );
}

export function DesktopNotificationBar() {
  return (
    <div className="hidden lg:flex items-center justify-end px-8 py-2 bg-white/80 backdrop-blur-sm border-b border-gray-100 sticky top-0 z-20">
      <NotificationBell />
    </div>
  );
}
